// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { ConfirmExternalReceptionByIdData, ConfirmExternalReceptionByIdErrors, ConfirmExternalReceptionByIdResponses, GetExternalReceptionByIdData, GetExternalReceptionByIdErrors, GetExternalReceptionByIdResponses, UpdateExternalReceptionByIdData, UpdateExternalReceptionByIdErrors, UpdateExternalReceptionByIdResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const getExternalReceptionById = <ThrowOnError extends boolean = false>(options: Options<GetExternalReceptionByIdData, ThrowOnError>) => (options.client ?? client).get<GetExternalReceptionByIdResponses, GetExternalReceptionByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/external-receptions/{id}',
    ...options
});

export const updateExternalReceptionById = <ThrowOnError extends boolean = false>(options: Options<UpdateExternalReceptionByIdData, ThrowOnError>) => (options.client ?? client).patch<UpdateExternalReceptionByIdResponses, UpdateExternalReceptionByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/external-receptions/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirms a draft PZ. A PZ with exact KSeF generation provenance also requires wms.ksef.link and atomically creates its final FZ/PZ link.
 */
export const confirmExternalReceptionById = <ThrowOnError extends boolean = false>(options: Options<ConfirmExternalReceptionByIdData, ThrowOnError>) => (options.client ?? client).post<ConfirmExternalReceptionByIdResponses, ConfirmExternalReceptionByIdErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/v1/external-receptions/{id}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
